module.exports = __webpack_public_path__ + "img/avatar-06-140x140.308e2e62.png";